import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {Configuration} from '@shared/models/configuration';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-treaty-status-viewer',
  templateUrl: './treaty-status-viewer.component.html',
  styleUrls: ['./treaty-status-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TreatyStatusViewerComponent implements OnInit {
  ngUnsubscribe$ = new Subject<void>();
  @Input() sourceKey: string;
  invalidateSubject: InvalidateSubject;
  country1: string;
  country2: string;
  @Input() id;

  constructor(private router:Router) {
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['ID'] = this.id;
  }

  onGridCellValueChange(event: any) {
    if(event.item && event.item.cells.Treaty.value === 'TREATY') {
      this.router.navigateByUrl(`treaties/${event.item.cells.CountryCode1.value}/${event.item.cells.CountryCode2.value}`);
    }
    if(event.item && event.item.cells.Treaty.value === 'BEPS MLI') {
      this.router.navigateByUrl(`treaties/${event.item.cells.CountryCode1.value}/${event.item.cells.CountryCode2.value}/mli`);
    }
  }

}
